// Global runtime config.
// The owner portal uses the real backend endpoints only.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = BACKEND_URL || "http://localhost:8080";
